<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import type { Language } from '$lib/types/Language';

    export let open = false;
    export let disabled = false;
    export let language: Language = 'en';
    export let twoColumn = false;
    export let handleClear: () => void;
    export let handleSave: () => void;

    const translations = {
        de: {
            clear: 'Löschen',
            save: 'Speichern',
        },
        en: {
            clear: 'Clear',
            save: 'Save',
        },
    };

    const borderRadius = getBorderRadius('button');

    const btnClasses = cn(
        borderRadius,
        `focus:before:${borderRadius}`,
        'fun-relative fun-h-12 fun-w-full fun-px-3 fun-py-2 fun-text-center fun-text-sm fun-font-bold focus:before:fun-absolute focus:before:fun--bottom-0.5 focus:before:fun--left-0.5 focus:before:fun--right-0.5 focus:before:fun--top-0.5 focus:before:fun-border focus:before:fun-border-blue-600 focus:before:fun-content-[""] disabled:fun-opacity-70',
    );
</script>

<div
    class="fun-grid fun-w-full fun-grid-cols-2 fun-gap-2 fun-bg-white fun-px-6 fun-py-4 fun-pt-0"
    class:fun-col-span-2={twoColumn}
>
    <button
        {disabled}
        on:click={handleClear}
        class={cn(
            'fun-bg-gray-100 fun-font-ui fun-text-gray-500 hover:fun-bg-gray-200 hover:fun-text-gray-600 disabled:fun-text-gray-500 disabled:hover:fun-bg-gray-100',
            btnClasses,
        )}
        tabindex={open ? '0' : '-1'}
    >
        {translations[language].clear}
    </button>
    <button
        {disabled}
        on:click={handleSave}
        class={cn(
            'disabled:hover:bg-unset fun-bg-blue-500 fun-font-sans fun-text-white hover:fun-bg-blue-600 disabled:fun-bg-blue-300',
            btnClasses,
        )}
        tabindex={open ? '0' : '-1'}
        type="button"
    >
        {translations[language].save}
    </button>
</div>
